<template>
  <v-select
    id="select"
    v-model="filter.indicadorGrupoId"
    item-text="nome"
    item-name="indicadorGrupoId"
    item-value="indicadorGrupoId"
    :items="grupoIndicador"
    label="Grupo de Indicadores"
    placeholder="Grupo de Indicadores"
    :disabled="disabled"
    @change="$emit('onChange')"
  >
    <template slot="no-data">
      Nada retornado
    </template>
  </v-select>
</template>

<script>
import { grupoIndicadorAPI } from '../API/grupoIndicadorAPI'
import { mapActions } from 'vuex'

export default {
  name: 'AppGrupoIndicadorCombobox',
  props: {
    filter: { type: Object },
    disabled: { type: Boolean, default: false }
  },
  mounted () {
    this.load()
  },
  methods: {
    ...mapActions([
      'setLoading'
    ]),
    load () {
      grupoIndicadorAPI.list()
        .then(resp => {
          this.grupoIndicador = resp.data
        })
        .catch()
    }
  },
  data () {
    return {
      grupoIndicador: []
    }
  }
}
</script>
